module.exports = __webpack_public_path__ + "static/media/06-Belgravia.d0cbe3a6.mp4";